module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-17.9bb4f253.png";